import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
import zodPTBR from 'zod-i18n-map/locales/pt/zod.json';
import translationPTBR from './locales/ptbr/translation.json';
import zodES from 'zod-i18n-map/locales/es/zod.json';
import translationES from './locales/es/translation.json';
import { getStoredLanguage } from '@/services/storage';

const resources = {
  es: { zod: zodES, translation: translationES },
  ptbr: { zod: zodPTBR, translation: translationPTBR },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage(),
    resources,
    fallbackLng: 'en',
    ns: ['translation', 'zod'],
    defaultNS: 'translation',
    detection: {
      order: ['localStorage', 'navigator'],
    },

    // allow keys to be phrases having `:`, `.`
    nsSeparator: false,
    // keySeparator: false,
    // debug: true
  });

z.setErrorMap(zodI18nMap);

export default i18n;
